import { defineMessages } from 'react-intl';

export const clinicianUpgradeCheckoutMessages = defineMessages({
  title: {
    defaultMessage: 'Upgrade your plan',
    id: '+jCAQllKOI',
    description: 'Screen-reader heading of the individual clinician upgrade checkout',
  },
  planDetails: {
    defaultMessage: 'Plan details',
    id: 'eiflh5ZI3a',
    description:
      'Heading above the billing period and seat options in the clinician upgrade checkout',
  },
  seatGroup: {
    defaultMessage: 'Clinician seat',
    id: 'L+QL38tw0w',
    description:
      'Label above the Standard and Max seat options in the clinician upgrade checkout',
  },
  saveExtra: {
    defaultMessage: 'Extra {percent}% off',
    id: 'nWk58n4Xj0',
    description: 'Badge on the Max seat option for the yearly Max seat offer',
  },
  saveYearly: {
    defaultMessage: 'Save {percent}%',
    id: 'V7homtcdvA',
    description:
      'Badge on the yearly billing option in the clinician upgrade checkout showing the saving over monthly billing',
  },
  extraDiscountNextStep: {
    defaultMessage: 'Extra {percent}% discount and taxes applied in next step',
    id: 'csEXtIBjwl',
    description:
      'Note under the price estimate in the clinician upgrade checkout when the yearly Max seat offer applies at payment',
  },
  forIndividualClinicians: {
    defaultMessage: 'For individual clinicians',
    id: 'owkCBfpyce',
    description: 'Audience badge on the plan card in the clinician upgrade checkout',
  },
  clinicianStandard: {
    defaultMessage: 'Clinician',
    id: 'F0HYHNLkjO',
    description:
      'Plan name for the Clinician Standard seat in the clinician upgrade checkout',
  },
  clinicianMax: {
    defaultMessage: 'Clinician Max',
    id: 'fDjxDThKAf',
    description: 'Plan name for the Clinician Max seat in the clinician upgrade checkout',
  },
  perUserYear: {
    defaultMessage: 'user / year',
    id: 'ASJML2/wSY',
    description: 'Unit after the yearly plan price in the clinician upgrade checkout',
  },
  perUserMonth: {
    defaultMessage: 'user / month',
    id: 'ZwhM0HSqBZ',
    description: 'Unit after the monthly plan price in the clinician upgrade checkout',
  },
  perMonthBilledAnnually: {
    defaultMessage: '{price} user/month billed annually',
    id: '+Q/5KlgaUu',
    description:
      'Per-month equivalent under a yearly plan price in the clinician upgrade checkout',
  },
  everythingInScribePlus: {
    defaultMessage: 'Everything in Scribe Plus, plus:',
    id: 'As6voJiF7M',
    description:
      'Heading of the feature list on the clinician upgrade checkout plan card',
  },
  everythingInFree: {
    defaultMessage: 'Everything in Free, plus:',
    id: 'olOCAsBl5d',
    description:
      'Heading of the feature list on the clinician upgrade checkout plan card when a Free or Clinician Standard member upgrades',
  },
  featureCustomTemplates: {
    defaultMessage: 'Custom scribe templates',
    id: 'X0ImJuJkvP',
    description:
      'Feature on the clinician upgrade checkout plan card when a Free or Clinician Standard member upgrades',
  },
  featureEvidenceAnswers: {
    defaultMessage: 'Evidence answers in patient sessions',
    id: '9zn+klNJcJ',
    description: 'Feature on the clinician upgrade checkout plan card',
  },
  featureEvidenceSources: {
    defaultMessage: 'Choose your preferred Evidence sources',
    id: 'nXOysQhH1l',
    description: 'Feature on the clinician upgrade checkout plan card',
  },
  featureTryAgentic: {
    defaultMessage: 'Try agentic workflows',
    id: '78j+BhJ0p6',
    description: 'Feature on the Clinician Standard plan card in the upgrade checkout',
  },
  featureDailyAgentic: {
    defaultMessage: 'Daily use of agentic workflows',
    id: '9EdL+DZ0ei',
    description: 'Feature on the Clinician Max plan card in the upgrade checkout',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'Emh8RNigR+',
    description:
      'Primary button in the clinician upgrade checkout that goes on to payment',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'K1Awr2Pk3L',
    description: 'Button in the clinician upgrade checkout that leaves without upgrading',
  },
});
